"use client"

import Image from "next/image"
import Link from "next/link"
import { useIsMobile } from "@/hooks/use-is-mobile"

const AboutUs = () => {
  const { isMobile } = useIsMobile()

  return (
    <div className="mt-[60px] bg-[#D7E1BD] px-[16px] pb-[40px] pt-[30px]">
      <div className="flex flex-col lg_mx-auto lg_w-[1440px] lg_flex-row-reverse">
        <div className="lg_flex-1/2 w-full">
          <Image
            className="w-full"
            width={isMobile ? 515 : 1104}
            height={isMobile ? 411 : 788}
            src={isMobile ? "/home/about-mobile.png" : "/home/about.png"}
            layout="responsive"
          />
        </div>

        <div className="relative flex flex-col lg_justify-center lg_pl-[70px] lg_pr-[55px]">
          <p className="mb-[10px] mt-[30px] font-poppins text-[22px] font-[600] leading-[1.4] text-primary lg_mb-[20px] lg_text-[30px]">
            About Kingsyard
          </p>
          <p className="mb-[20px] font-sans text-sm leading-[1.4] text-[#2F2F2F] lg_text-[16px]">
            Kingsyard strives to be the most trusted brand in wild bird feeding
            by providing bird lovers with high quality, cost-effective bird
            feeding series they need. Bird feeding isn't just our specialty -
            it's our lifestyle.
          </p>
          <p className="mb-[20px] font-sans text-sm leading-[1.4] text-[#2F2F2F] lg_mb-[40px] lg_text-[16px]">
            We love feeding, watching, and learning about our feathered friends,
            and we know you do too!{" "}
          </p>
          <Link
            href="/about-us"
            className="h-[50px] w-[207px] cursor-pointer rounded-[10px] bg-primary px-[54px] font-poppins font-[600] uppercase leading-[54px] text-white hover_opacity-90"
          >
            Learn more
          </Link>

          <div className="absolute left-0 top-0 hidden h-[69px] w-[69px] bg-[#A1C323] lg_block" />
        </div>
      </div>
    </div>
  )
}

export default AboutUs
